export function DomainIdentifier(): string {
    const url = window.location.origin;

    if (isLocalEnvironment(url)) {
        return getLocalDomain();
    } else if (isLowerEnvironment(url)) {
        return getLowerEnvironmentDomain(url);
    } else {
        return getProductionDomain(url);
    }
}

function isLocalEnvironment(url: string): boolean {
    return url.includes('localhost');
}

function getLocalDomain(): string {

    const url = globalThis.location.pathname; // Get the full path of the current URL
    const conceptId: any = (document.getElementById('conceptId') as HTMLInputElement)?.value;
    // check if the path includes '/ca'
    if (url.toLowerCase().includes('/ca') && (conceptId === process.env.CONCEPT_NBLY || conceptId === process.env.CONCEPT_CORP)) {
        return 'ca';
    }
    const assetPathElement = document.getElementById("assetPath") as HTMLInputElement;
    if (assetPathElement) {
        const assetPathValue = assetPathElement.value;
        if (assetPathValue.includes("/US/")) {
            return 'us';
        } else if (assetPathValue.includes("/CA/")) {
            return 'ca';
        }
    }
    return "Error validating Location";
}

function isLowerEnvironment(url: string): boolean {
    return url.includes('nblysbx') || url.includes('nblydev') || url.includes('nblytest') || url.includes('nblyprod');
}

function getLowerEnvironmentDomain(url: string): string {
    try {
          // Check if the URL path contains '/ca' (for all environments)
        const conceptId: any = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        const pathname = window.location.pathname;

        if ((pathname.toLowerCase().includes('/ca') || url.toLowerCase().includes('/ca')) && (conceptId === process.env.CONCEPT_NBLY || conceptId === process.env.CONCEPT_CORP)) {
            return 'ca';
        }

        if (url.includes('-ca-') || (url.includes('-ca') &&  url.includes('nblyprod'))) {
            return 'ca';
        } else {
            return 'us';
        }
    } catch {
        return "Error validating Location";
    }
}

function getProductionDomain(url: string): string {
    try {
        // Check if the URL path contains '/ca'
        const conceptId: any = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        const pathname = window.location.pathname;  

        if ((pathname.toLowerCase().includes('/ca') || url.toLowerCase().includes('/ca')) && (conceptId === process.env.CONCEPT_NBLY || conceptId === process.env.CONCEPT_CORP)) {
            return 'ca';
        }
        const lastDotIndex = url.lastIndexOf('.');
        const domainExtension = url.substring(lastDotIndex + 1);
        if (domainExtension === "ca") {
            return 'ca';
        } else {
            return 'us';
        }
    } catch {
        return "Error validating Location";
    }
}